export default "__VITE_ASSET__9ec2c4bb__"